"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SessionEnum;
(function (SessionEnum) {
    SessionEnum["CONTEXT"] = "context";
    SessionEnum["USER"] = "user";
    SessionEnum["I18N"] = "i18n";
    SessionEnum["AUTHORIZE"] = "authorize";
    SessionEnum["TOKEN"] = "token";
    SessionEnum["FIELD_ONE"] = "fieldOneValue";
    SessionEnum["FIELD_TWO"] = "fieldTwoValue";
    SessionEnum["SENDER_CODE"] = "senderCodeValue";
})(SessionEnum || (SessionEnum = {}));
exports.default = SessionEnum;
